import { useState, useMemo, useCallback } from "react";
import {
  DEFAULT_FILTERS,
  DEFAULT_PAGINATION,
  SERVICE_CODE_MAP,
} from "../constants/transactionConstants";

export const useTransactionFilters = (isSuperAdmin = false) => {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);

  const apiFilters = useMemo(() => {
    const { searchQuery, dateRange, serviceFilter } = filters;
    const serviceCodes = SERVICE_CODE_MAP[serviceFilter] || [];

    return {
      searchQuery: searchQuery || "",
      startDate: dateRange?.startDate || "",
      endDate: dateRange?.endDate || "",
      serviceCodes,
      page: pagination.pageIndex,
      size: pagination.pageSize,
    };
  }, [filters, pagination.pageIndex, pagination.pageSize]);

  const managementApiFilters = useMemo(() => {
    if (!isSuperAdmin) return apiFilters;

    const formattedFilters = { ...apiFilters };

    if (filters.merchantId) {
      formattedFilters.merchantId = filters.merchantId;
    }

    return formattedFilters;
  }, [apiFilters, isSuperAdmin, filters.merchantId]);

  const setSearchQuery = useCallback((query) => {
    setFilters((prev) => ({ ...prev, searchQuery: query }));
  }, []);

  const setDateRange = useCallback((rangeOutput) => {
    setFilters((prev) => ({
      ...prev,
      dateRange: {
        startDate: rangeOutput?.startDate || null,
        endDate: rangeOutput?.endDate || null,
      },
    }));
  }, []);

  const setServiceFilter = useCallback((value) => {
    setFilters((prev) => ({ ...prev, serviceFilter: value || "all" }));
  }, []);

  const setMerchantId = useCallback((id) => {
    setFilters((prev) => ({ ...prev, merchantId: id || "" }));
  }, []);

  const resetPagination = useCallback(() => {
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  }, []);

  return {
    filters,
    pagination,
    apiFilters,
    managementApiFilters,
    setPagination,
    resetPagination,
    searchQuery: filters.searchQuery,
    dateRange: filters.dateRange,
    serviceFilter: filters.serviceFilter,
    merchantId: filters.merchantId,
    setSearchQuery,
    setDateRange,
    setServiceFilter,
    setMerchantId,
  };
};

export default useTransactionFilters;
